const TEAM = [
  {
    name: "Clayton MacKay",
    role: "CEO",
    photo: "/team/clayton.jpg",
    bio: "Co-Founder and CEO of Java Group Programs, Clayton brings many years of business experience to MyJava.ai. He has first-hand experience of the strong impact peer support groups have on combatting loneliness in older adults.",
  },
  {
    name: "Dr. Kristine Theurer",
    role: "President, Creative Director",
    photo: "/team/kristine.png",
    bio: "Researcher pioneering standardized peer support and peer mentoring programs for loneliness and social isolation in senior living. Published author with over a decade of in-the-field deployment experience.",
  },
  {
    name: "Nik Edmiidz",
    role: "CTO",
    photo: "/team/nik.jpg",
    bio: "Leads MyJava's technical vision with a strong track record in voice technology, conversational interfaces, and AI-assisted prototyping. Hands-on architect of the MyJava platform across telephony and smart-speaker surfaces.",
  },
  {
    name: "Adrian MacKay",
    role: "CFO",
    photo: "/team/adrian.jpg",
    bio: "Strategy & Operations professional with a track record of delivering operational improvements and visionary strategies. Value investor from the Ben Graham Centre for Value Investing.",
  },
];

export default function AboutUs() {
  return (
    <>
      <section className="hero">
        <div className="container">
          <h1>The MyJava team</h1>
          <p className="lead">
            We're a small team of researchers, operators, and engineers who
            believe loneliness is a problem we can actually solve — at scale.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="grid two">
            {TEAM.map((m) => (
              <div className="card team-card" key={m.name}>
                <img src={m.photo} alt={`${m.name} headshot`} />
                <h3>{m.name}</h3>
                <div className="role">{m.role}</div>
                <p style={{ marginTop: 12 }}>{m.bio}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
